import { render, staticRenderFns } from "./grnPage.vue?vue&type=template&id=c3bc0702&scoped=true&"
import script from "./grnPage.vue?vue&type=script&lang=js&"
export * from "./grnPage.vue?vue&type=script&lang=js&"
import style0 from "./grnPage.vue?vue&type=style&index=0&id=c3bc0702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bc0702",
  null
  
)

export default component.exports